import React from "react";
import NavBar from "./components/NavBar";
import { useAuth0 } from "./react-auth0-spa";
import EBSHTower from "./components/EBSHTower";
import GolfStatusPage from "./components/GolfStatusPage";
import { Router, Route, Switch } from "react-router-dom";
import history from "./utils/history";
import Loading from "./components/Loading";
import { Container } from "reactstrap";

function App() {
  const { loading } = useAuth0();
  console.log(loading);

  if (loading) {
    console.log("Loading");
    return (
      <div>
        <Loading />
      </div>
    );
  }
  const { user, isAuthenticated } = useAuth0();
  //console.log(user);

  console.log("Rendering");
  return (
    <Router history={history}>
      <div>
        <div className="App">
          <header>
            <NavBar />
          </header>
        </div>
        <Container className="flex-grow-1 mt-5">
          <Switch>
            {isAuthenticated && (
              <Route
                path="/"
                render={props => <EBSHTower {...props} user={user.email} />}
              />
            )}
          </Switch>
          <Switch>
            {!isAuthenticated && (
              <Route
                path="/"
                render={props => <GolfStatusPage {...props} />}
              />
            )}
          </Switch>
        </Container>
      </div>
    </Router>
  );
}

export default App;
